import { useEffect } from 'react';
import { createPortal } from 'react-dom';
var el = typeof document !== 'undefined' ? document.createElement('div') : null;
var Portal = function Portal(_ref) {
  var children = _ref.children;
  useEffect(function () {
    document.body.appendChild(el);
  }, []);
  if (!el) {
    return null;
  }
  return /*#__PURE__*/createPortal(children, el);
};
export default Portal;